/**
 * App Component — Gateway-only, simplified
 */
import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router-dom'
import { ConfigProvider, App as AntApp, Spin } from 'antd'
import { QueryClientProvider } from '@tanstack/react-query'
import { router } from '@routes/index'
import { queryClient } from '@shared/config'
import { adminTheme } from '@shared/theme'
import { authActions } from '@store/authStore'
import { ErrorBoundary } from '@presentation/components'

function AppContent() {
  return (
    <ConfigProvider theme={adminTheme}>
      <AntApp>
        <RouterProvider router={router} />
      </AntApp>
    </ConfigProvider>
  )
}

function LoadingScreen() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#f9fafb',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      <Spin size="large" />
      <span style={{ color: '#666' }}>Initializing application...</span>
    </div>
  )
}

function App() {
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    // Initialize auth store from localStorage
    authActions.initialize()
    setIsInitialized(true)
  }, [])

  if (!isInitialized) {
    return <LoadingScreen />
  }

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppContent />
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

export default App
